import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import MachineTable from './machine-table';
import MachineTile from './machine-tile';
import MachineSearch from './machine-search';
import { selectTileView } from './store/selectors'; 
import MachineNavBar from './machine-nav-bar';

const MachineContent = props => {
  const showTileView = useSelector(selectTileView); 
  const [activeLane, setActiveLane] = useState('ALL');
  const [unit, setUnit] = useState('mm');

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top w-100 d-flex align-items-center" style={{ position: 'relative' }}>
          <MachineSearch />
          <div style={{ 
            display: 'flex', 
            gap: 12,
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)'
          }}>
            <button
              onClick={() => setUnit('mm')}
              style={{
                padding: '8px 24px',
                borderRadius: '8px',
                border: `1px solid ${unit === 'mm' ? '#28a745' : '#dee2e6'}`,
                backgroundColor: unit === 'mm' ? '#d4edda' : '#f8f9fa',
                color: unit === 'mm' ? '#155724' : '#6c757d',
                fontWeight: unit === 'mm' ? 600 : 400,
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'all 0.3s',
                boxShadow: unit === 'mm' ? '0 2px 4px rgba(40, 167, 69, 0.2)' : '0 1px 2px rgba(0,0,0,0.1)'
              }}
              onMouseEnter={(e) => {
                if (unit !== 'mm') {
                  e.target.style.backgroundColor = '#e9ecef';
                }
              }}
              onMouseLeave={(e) => {
                if (unit !== 'mm') {
                  e.target.style.backgroundColor = '#f8f9fa';
                }
              }}
            >
              mm
            </button>
            <button
              onClick={() => setUnit('inches')}
              style={{
                padding: '8px 24px',
                borderRadius: '8px',
                border: `1px solid ${unit === 'inches' ? '#ffc107' : '#dee2e6'}`,
                backgroundColor: unit === 'inches' ? '#fff3cd' : '#f8f9fa',
                color: unit === 'inches' ? '#856404' : '#6c757d',
                fontWeight: unit === 'inches' ? 600 : 400,
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'all 0.3s',
                boxShadow: unit === 'inches' ? '0 2px 4px rgba(255, 193, 7, 0.2)' : '0 1px 2px rgba(0,0,0,0.1)'
              }}
              onMouseEnter={(e) => {
                if (unit !== 'inches') {
                  e.target.style.backgroundColor = '#e9ecef';
                }
              }}
              onMouseLeave={(e) => {
                if (unit !== 'inches') {
                  e.target.style.backgroundColor = '#f8f9fa';
                }
              }}
            >
              inches
            </button>
          </div>
        </div>
        <div className="d-flex">
          <MachineNavBar onLaneChange={setActiveLane} activeLane={activeLane} />
          {!showTileView ? <MachineTable activeLane={activeLane} unit={unit} /> : <MachineTile />}
        </div>
      </div>
    </div>
  );
};

export default MachineContent;